import BaseController from './BaseController'
import Scrollbar from 'smooth-scrollbar'

export default class AvantageController extends BaseController {

  init() {
    this.initScrollbar()
    // this.revealAnimate()
    // this.listeners()
    // this.openings()
    // this.contact()

    this.$dones = []
  }

  listeners() {
    // this.scrollbar.addListener(() => { this._handleReveals() })
  }

}